import { DatePickerComponent, DateTimePickerComponent } from '@progress/kendo-angular-dateinputs';

/**
 * Configure Kendo UI DatePicker and DateTimePicker to default to the 'classic' calendar layout.
 *
 * Benefits of 'classic' layout:
 * - Single-month paginated view with intuitive navigation controls (< and >)
 * - Clear month/year zoomable title to easily jump between months, years, and decades
 * - Avoids the clumsy, unstyled infinite-scrolling months list on the side
 * - Consistent, clean calendar experience across all date and datetime fields
 */
function configureKendoDateDefaults() {
  const patchComponent = (componentClass: any) => {
    if (!componentClass || !componentClass.prototype) return;

    Object.defineProperty(componentClass.prototype, 'calendarType', {
      get() {
        return this._customCalendarType !== undefined ? this._customCalendarType : 'classic';
      },
      set(val) {
        this._customCalendarType = val;
        if (this._calendarType && typeof this._calendarType.set === 'function') {
          this._calendarType.set(val);
        }
      },
      configurable: true,
      enumerable: true
    });

    Object.defineProperty(componentClass.prototype, 'animateCalendarNavigation', {
      get() {
        return this._customAnimateCalendarNavigation !== undefined ? this._customAnimateCalendarNavigation : true;
      },
      set(val) {
        this._customAnimateCalendarNavigation = val;
        if (this._animateCalendarNavigation && typeof this._animateCalendarNavigation.set === 'function') {
          this._animateCalendarNavigation.set(val);
        }
      },
      configurable: true,
      enumerable: true
    });
  };

  patchComponent(DatePickerComponent);
  patchComponent(DateTimePickerComponent);
}

configureKendoDateDefaults();
